import { QuoteType } from '@nibtravel/shared/util/models';
import {
  IPolicyHolderAgeConfig,
  ITravelDurationConfig,
  ITravelRestrictionConfig,
} from '@nibtravel/shared/util/models';

/**
 * Interface that represents the quote config
 * data coming from the API
 */
export interface IQuoteConfig {
  expirySeconds: number;
  minTravellers: number;
  maxTravellers: number;
  minDependents: number;
  maxDependents: number;
  travelDurationConfigs: ITravelDurationConfig[];
  policyHolderAgeConfigs: IPolicyHolderAgeConfig[];
  travelRestrictionConfigs: ITravelRestrictionConfig[];
  maxTripValuePerTraveller: number;
}

/**
 * Interface with extended properties that includes runtime
 * mapping for faster data access.
 */
export interface IQuoteConfigWithMaps extends IQuoteConfig {
  travelDurationConfigsMap: DurationConfigMap;
  policyHolderAgeConfigsMap: PolicyHolderConfigMap;
  travelRestrictionConfigsMap: RestrictionsConfigMap;
}

/** The type exposed as state object */
export type QuoteConfigStateModel = Record<string, IQuoteConfigWithMaps>;

/** The type that represents the travel duration configuration map */
export type DurationConfigMap = Record<string, ITravelDurationConfig>;

/** The type that represents the travel restrictions configuration map */
export type RestrictionsConfigMap = Record<string, ITravelRestrictionConfig>;

/** The type that represents the policy holder configuration map */
export type PolicyHolderConfigMap = Record<string, IPolicyHolderAgeConfig>;

export const emptyQuoteConfigWithMaps = {
  expirySeconds: 0,
  minTravellers: 0,
  maxTravellers: 0,
  minDependents: 0,
  maxDependents: 0,
  travelDurationConfigs: [],
  policyHolderAgeConfigs: [],
  travelRestrictionConfigs: [],
  maxTripValuePerTraveller: 0,
  travelDurationConfigsMap: {},
  policyHolderAgeConfigsMap: {},
  travelRestrictionConfigsMap: {},
};

export const defaultQuoteConfig: QuoteConfigStateModel = {
  [QuoteType.SingleTrip]: {
    ...emptyQuoteConfigWithMaps,
  },
  [QuoteType.MultiTrip]: {
    ...emptyQuoteConfigWithMaps,
  },
};
